export default __webpack_public_path__ + "static/media/serial_servo.c70adfad.png";